import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.completehomework;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,

    COMPLETE_HOMEWORK_ASYNC: `${uid}.completeHomeworkAsync`,
    COMPLETE_HOMEWORK_SUCCESS: `${uid}.completeHomeworkSuccess`,
    COMPLETE_HOMEWORK_FAILURE: `${uid}.completeHomeworkFailure`,

    REDO_HOMEWORK_ASYNC: `${uid}.redoHomeworkAsync`,
    REDO_HOMEWORK_SUCCESS: `${uid}.redoHomeworkSuccess`,
    REDO_HOMEWORK_FAILURE: `${uid}.redoHomeworkFailure`,

    MAKEUP_ASYNC: `${uid}.makeupAsync`,
    MAKEUP_SUCCESS: `${uid}.makeupSuccess`,
    MAKEUP_FAILURE: `${uid}.makeupFailure`,

    SHOW_MODAL: `${uid}.showModal`,
    SHOW_REDO: `${uid}.showRedo`,
    SHOW_TIP_STATUS: `${uid}.showTipStatus`,
};

export { ActionTypes };
